export function useGetCubeToken() {
    const createCubeTokenOnLoad = async ({ selectedAccount, signal, dataTableList, useDemoData, customJoinList }) => {
        try {
            const response = await fetch(`/api/initialize-cube`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ selectedAccount, dataTableList, useDemoData, customJoinList }),
                signal, 
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`Error in createCubeTokenOnLoad: ${errorData}`);
            }

            const data = await response.json();
            return data;
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.error('Fetch error:', err);
            }
            return null;
        }
    };

    return { createCubeTokenOnLoad };
}